import React from 'react'
import { motion } from 'framer-motion'
import { ebookStore } from '../store/ebookStore'

const NavigationBar = ({ currentView, onBack, showBack }) => {
  const { getTotalProgress, bookmarks } = ebookStore()
  const progress = getTotalProgress()

  return (
    <nav className="navbar">
      <div className="nav-left">
        {showBack && (
          <motion.button 
            className="back-btn"
            onClick={onBack}
            whileHover={{ x: -3 }}
            whileTap={{ scale: 0.95 }}
          >
            ← Volver
          </motion.button>
        )}
      </div>

      <div className="nav-center">
        <span className="nav-title">Guía Vibracional</span>
      </div>

      <div className="nav-right">
        {currentView === 'chapter' && (
          <div className="nav-progress">
            <div className="progress-ring">
              <svg viewBox="0 0 36 36">
                <path
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="rgba(255,255,255,0.2)"
                  strokeWidth="2"
                />
                <path
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#a78bfa"
                  strokeWidth="2"
                  strokeDasharray={`${progress}, 100`}
                  strokeLinecap="round"
                />
              </svg>
              <span className="progress-text">{progress}%</span>
            </div>
          </div>
        )}
        {currentView === 'contents' && (
          <div className="nav-bookmarks">
            <span className="bookmark-count">🔖 {bookmarks.length}</span>
          </div>
        )}
      </div>
    </nav>
  )
}

export default NavigationBar
